import React, { useState, useEffect, useRef } from 'react';
import { Document, Page } from 'react-pdf';

const PdfComp = React.forwardRef((props, ref) => {
  const [numPages, setNumPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1); // State for scale
  const containerRef = useRef(null); // Ref to access the container's dimensions

  // When the document loads successfully
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    if (props.onPageChange) {
      props.onPageChange(1); // Notify parent of the initial page number
    }
  }

  // Page navigation functions
  function goToNextPage() {
    if (pageNumber < numPages) {
      const nextPage = pageNumber + 1;
      setPageNumber(nextPage);
      if (props.onPageChange) {
        props.onPageChange(nextPage); // Notify parent of the new page number
      }
    }
  }

  function goToPrevPage() {
    if (pageNumber > 1) {
      const prevPage = pageNumber - 1;
      setPageNumber(prevPage);
      if (props.onPageChange) {
        props.onPageChange(prevPage); // Notify parent of the new page number
      }
    }
  }

  // Set the scale based on the container's size
  useEffect(() => {
    const resizeHandler = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        const containerHeight = containerRef.current.offsetHeight;

        // Calculate scale to fit the container
        const scale = Math.min(containerWidth / 600, containerHeight / 800); // 600x800 is typical page size
        setScale(scale);
      }
    };

    // Initial resize check
    resizeHandler();

    // Listen for window resize events to adjust the scale
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  if (!props.pdffile) {
    return <div>No PDF available</div>;
  }

  return (
    <div className="pdf-frame" ref={ref}>
      <Document
        file={props.pdffile}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={(error) => console.error("Error loading PDF:", error)}
        onClick={props.callback}
      >
        <p>
          Page {pageNumber} of {numPages}
        </p>
        <Page
          pageNumber={pageNumber}
          scale={scale}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>

      <div>
        <button onClick={goToPrevPage} disabled={pageNumber === 1}>
          Previous
        </button>
        <button onClick={goToNextPage} disabled={pageNumber === numPages}>
          Next
        </button>
      </div>
    </div>
  );
});

export default PdfComp;
